<template>
  <div class="action-container">
    <div class="part-item">
      <a class="download-action" :href="MATR1XFIREDOWNLOADLINKIOS" target="_blank">
        <button class="btn">
          <svg-icon icon-class="download_app_store_black" class-name="action-svg"
            style="width: 30px; height: 32px"></svg-icon>
          <div class="download-resource">
            <span>Download on the</span>
            <span class="large-text">App Store</span>
          </div>
        </button>
      </a>
      <a class="download-action" :href="MATR1XFIREDOWNLOADLINKANDROID" target="_blank">
        <button class="btn">
          <svg-icon icon-class="download_google_play_black" class-name="action-svg"
            style="width: 30px; height: 32px"></svg-icon>
          <div class="download-resource">
            <span>Get It On</span>
            <span class="large-text">Google Play</span>
          </div>
        </button>
      </a>
      <el-popover placement="top" popper-class="qrcode-popper" trigger="hover" :visible-arrow="false">
        <img src="@/assets/images/matr1xFireIntro/qrcode.png" width="130" height="130" alt="qrcode" />
        <a slot="reference" class="download-action download-qrcode">
          <button class="btn">
            <svg-icon icon-class="matr1x_fire_qrcode" class-name="action-svg"
              style="width: 42px; height: 42px; color: #000;"></svg-icon>
          </button>
        </a>
      </el-popover>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import { MATR1XFIREDOWNLOADLINKIOS, MATR1XFIREDOWNLOADLINKANDROID } from "@/config";
export default {
  name: "ActionBtns",
  mixins: [responsiveMixin],
  components: {},
  data() {
    return {
      MATR1XFIREDOWNLOADLINKIOS, MATR1XFIREDOWNLOADLINKANDROID
    };
  },
  mounted() { },
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>